import OmegaTracker from "@didi/omega-tracker-lite";
import * as XTracker from "@didi/x-tracker";
import { inApp, SOFI_TERMINAL_ID } from "@/common/js/constant";
import { ClientStatus } from "@/common/js/clientStatus";
import { urlQuery } from '@/utils/url';
// 解析URL参数
const params: URLSearchParams = new URLSearchParams(window.location.search);

// 配置Omega
const Omega = OmegaTracker.getTracker({
  appKey: "omega2e5be5ff51",
  // 国际化Sofi数据展业方案 https://cooper.didichuxing.com/docs/document/2200043391121
  uploadHost: "omgup.didipay.com",
  // 全局点击事件监控，如不需要 建议关闭
  autoClick: false,
  // 断开桥接
  // @荣浩 20240822 支持埋点测试方案改动: 1. 删除disableBridge 2. 增加attrs配置
  // disableBridge: true,
  attrs: {
    omg_upload_channelId: "sofi_channel",
  },
});

// omega公参存储KEY
const KEY_FOR_OmegaAttrs: string = "KFOA";

// 设置公参
XTracker.setCommonAttrs({
  pub_biz_line: "fin",
  pub_subbiz: "sofi",
  pub_uid: params.get("uid") || "",
  pub_from_page: "",
  pub_page: "",
  // 客户端类型
  client_status: inApp ? ClientStatus.inApp : ClientStatus.webApp,
  // 增加terminal ID
  terminal_id: SOFI_TERMINAL_ID,
  // 增加资源位参数
  resource_id: params.get("resource_id") || "",
  // 增加扩展参数
  ext_params: urlQuery['ext'] || urlQuery['ext_params'] || '',
  // 增加渠道信息参数
  channel_info_list: urlQuery['channel_info_list'] || '',
});

// 从session中恢复公参
try {
  const sessionContent: string | null = window.sessionStorage.getItem(KEY_FOR_OmegaAttrs);
  if (sessionContent) {
    XTracker.setCommonAttrs(JSON.parse(sessionContent));
  }
} catch (e) {
  console.log("session恢复Omega公参失败");
}

// 建立血缘关系
XTracker.setBlood("pub_from_page", "pub_page");

// 设置
XTracker.setTracker((event_id: string, event_attrs: object, addition: any) => {
  // H5
  Omega?.trackEvent(event_id, addition?.tag, event_attrs);
});

// 事件上报
export const trackEvent = (event_id: string, event_attrs: object, addition?: any) =>
  XTracker.trackEvent(event_id, event_attrs, addition);
// 设置公参
export const setCommonAttrs = (attrs: object) => {
  XTracker.setCommonAttrs(attrs);
  // 利用session备份公参
  try {
    window.sessionStorage.setItem(KEY_FOR_OmegaAttrs, JSON.stringify(XTracker.getCommonAttrs()));
  } catch (e) {
    console.log("session备份Omega公参失败");
  }
};
